import { render, staticRenderFns } from "./workshops-list.vue?vue&type=template&id=1d04c41a&scoped=true"
import script from "./workshops-list.vue?vue&type=script&lang=js"
export * from "./workshops-list.vue?vue&type=script&lang=js"
import style0 from "./workshops-list.vue?vue&type=style&index=0&id=1d04c41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d04c41a",
  null
  
)

export default component.exports